import {Button, ButtonProps, Theme, useTheme} from '@mui/material';
import React, {ReactNode} from 'react';
import {makeStyles} from "@mui/styles";
import {hexToRgba} from "../../utils/FormatUtils";
import cx from "classnames"
import {Loader} from "./Loader";
interface StylesProps {
    readonly background: string;
    readonly color: string
}
const useStyle = makeStyles((theme: Theme) => ({
    root: {
        backgroundColor: (props: StylesProps) => `${props.background}!important` as any,
        color: (props: StylesProps) => `${props.color}!important` as any,
        fontSize: theme.typography.pxToRem(15),
        padding: `${theme.typography.pxToRem(12)} ${theme.typography.pxToRem(32)} !important` as any,
        textTransform: "none !important" as any,
        fontWeight: "700 !important" as any,
        whiteSpace: "nowrap",
        "&.css-8c72aq-MuiButtonBase-root-MuiButton-root:hover" : {
            background: hexToRgba(theme.palette.primary.main, {opacity: 0.9})
        },
        "& .MuiSvgIcon-root": {
            marginRight: theme.typography.pxToRem(9),
            fontSize: theme.typography.pxToRem(22),
        },
        "&:disabled": {
            background: `${theme.palette.grey[700]}!important` as any,
            color: "#f4f4f4!important",
            cursor: "not-allowed !important" as any,
            pointerEvents: "all !important" as any
        }
    }
}));

interface Props extends ButtonProps{
    readonly className?: string;
    readonly background?: string;
    readonly textColor?: string;
    readonly icon?: ReactNode
    readonly children: ReactNode;
    readonly loading?: boolean;
    readonly [key: string]: any
}

export function AppButton({children, className,loading, background,textColor,  icon, ...props}:Props) {
    const theme = useTheme();

    const classes = useStyle({background: background || theme.palette.text.primary, color: textColor || theme.palette.common.white});
    return (
        <Button {...props} variant="contained"  className={cx(classes.root, className)}>
            {loading && <Loader color="#fff" />}
            {!loading && children}
        </Button>
    );
}

